var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "file-chooser-toolbar",
    },
    [
      _vm.showButtons
        ? _c(
            "button",
            {
              staticClass: "button",
              attrs: {
                disabled: !_vm.canAddFolder,
              },
              on: {
                click: _vm.addFolder,
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$gettext("Ordner hinzufügen")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFolderAdder
        ? _c(
            "form",
            {
              staticClass: "inline-form",
              on: {
                submit: function submit($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "label",
                {
                  attrs: {
                    for: "file-chooser-add-folder",
                  },
                },
                [_vm._v(_vm._s(_vm.$gettext("Ordner hinzufügen")) + ":")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newFolderName,
                    expression: "newFolderName",
                  },
                ],
                attrs: {
                  id: "file-chooser-add-folder",
                  type: "text",
                  placeholder: _vm.$gettext("Ordnername"),
                },
                domProps: {
                  value: _vm.newFolderName,
                },
                on: {
                  input: function input($event) {
                    if ($event.target.composing) return
                    _vm.newFolderName = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "inline-buttons",
                },
                [
                  _c(
                    "button",
                    {
                      attrs: {
                        title: _vm.$gettext("Ordner anlegen"),
                      },
                      on: {
                        click: _vm.createFolder,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "accept",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        title: _vm.$gettext("Abbrechen"),
                      },
                      on: {
                        click: _vm.closeAddFolder,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "decline",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showButtons && !_vm.isFolderChooser
        ? _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: function click($event) {
                  return _vm.$refs.fileInput.click()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$gettext("Datei hinzufügen")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "fileInput",
        attrs: {
          type: "file",
          disabled: !_vm.canAddFile,
        },
        on: {
          change: _vm.updateUpload,
        },
      }),
      _vm._v(" "),
      _vm.showUpload
        ? _c(
            "form",
            {
              staticClass: "inline-form",
              on: {
                submit: function submit($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "label",
                {
                  attrs: {
                    for: "file-chooser-add-file",
                  },
                },
                [_vm._v(_vm._s(_vm.$gettext("Datei hinzufügen")) + ":")]
              ),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  id: "file-chooser-add-file",
                  title: _vm.$gettext("Datei auswählen"),
                  type: "text",
                  readonly: "",
                },
                domProps: {
                  value: _vm.uploadFileName,
                },
                on: {
                  click: function click($event) {
                    return _vm.$refs.fileInput.click()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "inline-buttons",
                },
                [
                  _c(
                    "button",
                    {
                      attrs: {
                        title: _vm.$gettext("Datei hochladen"),
                      },
                      on: {
                        click: _vm.createFile,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "accept",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        title: _vm.$gettext("Abbrechen"),
                      },
                      on: {
                        click: _vm.closeAddFile,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "decline",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }